import React from "react";
import Helper from "../../Helper";
import { useNavigate } from "react-router-dom";



function ApprovalDetails({ approvalHistory, approvalRequestId }) {

    const navigate = useNavigate();

    const latest =
        approvalHistory && approvalHistory.length > 0
            ? approvalHistory[0]   
            : null;

    return (
        <div className="card">
            <div className="card-body">

                <h6 className="mb-3">Approval Details</h6>

                {/* Approval Number */}
                <div className="row mb-2">
                    <div className="col-6">
                        <label className="col-form-label">Approval No</label>
                    </div>
                    <div className="col-6 text-end">
                        <span
                            className="hyperlink"
                            style={{ cursor: "pointer", fontSize: 12 }}
                            onClick={() =>
                                approvalRequestId &&
                                navigate("/approvals/view", { state: approvalRequestId })
                            }
                        >
                            {approvalRequestId || "-"}
                        </span>
                    </div>
                </div>

                {/* Approved By */}
                <div className="row mb-2">
                    <div className="col-6">
                        <label className="col-form-label">Approved By</label>
                    </div>
                    <div className="col-6 text-end">
                        <span className="view-label p">
                            {latest?.approver || "-"}
                        </span>
                    </div>
                </div>

                {/* Approval Date */}
                <div className="row mb-2">
                    <div className="col-6">
                        <label className="col-form-label">Approval Date</label>
                    </div>
                    <div className="col-6 text-end">
                        <span className="view-label p">
                            {latest?.timestamp
                                ? Helper.DateNormal(latest?.timestamp)
                                : "-"}
                        </span>
                    </div>
                </div>

                {/* Last Comment */}
                <div className="row">
                    <div className="col-6">
                        <label className="col-form-label">Last Comment</label>
                    </div>
                    <div className="col-6 text-end">
                        <span className="view-label p">
                            {latest?.comment || "-"}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ApprovalDetails;